export default "__VITE_PUBLIC_ASSET__9c5daa3f__"